import { gsap } from 'gsap'
import { breakpointDown } from './utils/breakpoints'

function initAccordion() {

  if(!$('.accordion').length) return

  let rows = $('.accordion .answer').length
  $('.accordion .accordion-row .answer-content').each(function (e){
    $(this).parent().attr('data-height', $(this).outerHeight())
    $(this).parent().css('max-height', 0)
    rows -= 1
    if(rows === 0) {
      gsap.fromTo('.accordion', { opacity: 0, y: 25 }, { opacity: 1, y: 0, duration: 0.5 })
      gsap.fromTo('.page-footer', { opacity: 0, y: 25 }, { opacity: 1, y: 0, duration: 0.7 })
    }
  })

}

function initAccordionClick()
{

  $('body').on('click', '.accordion-row', function (e){
    let isActive = $(this).find('.question').hasClass('is-open')

    $('.accordion .is-open').removeClass('is-open')
    $('.accordion .answer').css('max-height', 0)

    if(!isActive){
      let answer = $(this).find('.answer')
      let dataHeight = answer.find('.answer-content').outerHeight()
      answer.css('max-height', dataHeight + 'px')
      $(this).find('.question').addClass('is-open')
    }

  })
}

function initCompanyAccordion()
{
  if(breakpointDown('sm')) {

    let firstRow = $('.company-category-row-0')
    let fistContent = firstRow.find('.companies-container')
    firstRow.addClass('opened')
    fistContent.slideDown()

    $('body').on('click', '.js-open-company-accordion', function (e){
      let row = $(this).closest('.js-action')
      let content = row.find('.companies-container')

      let opened_row = $('.category-row.opened')
      let opened_content = opened_row.find('.companies-container')

      opened_row.removeClass('opened')
      opened_content.slideUp()

      if(row.data('action-key') !== opened_row.data('action-key')) {
        row.addClass('opened')
        content.slideDown()
      }

    })
  }

}

$(window).on('load', function (){
  initAccordion()
  initAccordionClick()
  initCompanyAccordion()
})

export { initAccordion, initAccordionClick }


